import { PenLine } from 'lucide-react';
import { useState } from 'react';
import { useAccess } from '../../../lib/useAccess';
import { Button } from '../../../ui/Button';
import { Sheet } from '../../../ui/Dialog';
import { Section } from '../../../ui/Section';
import { Composer } from './Composer';
import { MailboxStatus } from './MailboxStatus';
import { ThreadList } from './ThreadList';
import { ThreadView } from './ThreadView';

/**
 * Wiadomości klienta (profil klienta → „Wiadomości”, Figma 05): stan skrzynki („Ostatnia synchronizacja: …”), wątki
 * klienta (najnowsze najpierw), podgląd wątku w panelu bocznym, „Nowa wiadomość” do klienta przez
 * Akceptację. Do wpięcia przez kompozycję (`setClientTab`).
 */
export function ClientMessages({ clientId, className }: { clientId: string; className?: string }) {
  const access = useAccess();
  const canWrite = access.can('inbox', 'edit');
  const [openThread, setOpenThread] = useState<string | null>(null);
  const [composeOpen, setComposeOpen] = useState(false);
  if (!access.can('inbox')) {
    return (
      <p className={className ?? 'text-body-s text-fg-muted'}>
        Wiadomości klienta są w module Inbox, do którego nie masz dostępu.
      </p>
    );
  }
  return (
    <Section aria-label="Wiadomości klienta" className={className}>
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <MailboxStatus compact className="min-w-0 flex-1" />
        {canWrite && (
          <Button size="s" variant="secondary" icon={PenLine} onClick={() => setComposeOpen(true)}>
            Nowa wiadomość
          </Button>
        )}
      </div>
      <ThreadList
        input={{ clientId }}
        onOpen={setOpenThread}
        empty={{
          title: 'Brak wiadomości z tym klientem.',
          description: 'Maile od kontaktów klienta pojawią się tutaj po synchronizacji skrzynki.',
        }}
      />
      <Sheet
        open={openThread !== null}
        onOpenChange={(open) => !open && setOpenThread(null)}
        title="Wątek"
        className="md:max-w-[640px]"
      >
        {openThread && <ThreadView threadId={openThread} headingLevel="h2" />}
      </Sheet>
      {canWrite && (
        <Composer open={composeOpen} onOpenChange={setComposeOpen} clientId={clientId} title="Nowa wiadomość" />
      )}
    </Section>
  );
}
